import featureFlags from '../constants/featureFlags';
import DEFINE, { PATHS } from '../constants/Define';

export default [{
    title: "vinpearlGolf",
    tagSub: "vinpearlGolf",
    exact: false,
    path: PATHS.GOLF_COURSE.path,
    show: true,
    icon: "faGolfBall",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.VINPEARL_GOLF,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "golfCourse",
            group: "golfCourse",
            path: PATHS.GOLF_COURSE.LIST.path,
            tagSub: "vinpearlGolf",
            exac: false,
            icon: "faMapMarked",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_COURSE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
            children: [
                {
                    title: "createGolfCourse",
                    group: "golfCourse",
                    tagSub: "vinpearlGolf",
                    path: PATHS.GOLF_COURSE.CREATE.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }, {
                    title: "updateGolfCourse",
                    group: "golfCourse",
                    tagSub: "vinpearlGolf",
                    path: PATHS.GOLF_COURSE.DETAIL.path,
                    exact: false,
                    icon: 'home',
                    show: false,
                }
            ]
        },
        // {
        //     title: "golfAddOnServices",
        //     group: "golfAddOnServices",
        //     path: PATHS.GOLF_ADD_ON_SERVICES.path,
        //     tagSub: "golfAddOnServices",
        //     exac: false,
        //     icon: "faDonate",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_ADD_ON_SERVICES,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
        // {
        //     title: "golfAddOnServicesCategory",
        //     group: "golfAddOnServicesCategory",
        //     path: PATHS.GOLF_ADD_ON_SERVICES_CATEGORY.path,
        //     tagSub: "golfAddOnServicesCategory",
        //     exac: false,
        //     icon: "faFolder",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_ADD_ON_SERVICES_CATEGORY,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
        // {
        //     title: "golfSpecialOffers",
        //     group: "golfSpecialOffers",
        //     path: PATHS.GOLF_SPECIAL_OFFERS.path,
        //     tagSub: "golfSpecialOffers",
        //     exac: false,
        //     icon: "faTicketAlt",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_SPECIAL_OFFERS,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
        // {
        //     title: "golfOrder",
        //     group: "golfOrder",
        //     path: PATHS.GOLF_ORDER.path,
        //     tagSub: "golfOrder",
        //     exac: false,
        //     icon: "faCoins",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_ORDER,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
        {
            title: "golfProductRevenueReport",
            group: "golfProductRevenueReport",
            path: PATHS.GOLF_PRODUCT_REVENUE_REPORT.path,
            tagSub: "golfProductRevenueReport",
            exac: false,
            icon: "faFileInvoiceDollar",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_PRODUCT_REVENUE_REPORT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        },
        // {
        //     title: "golfPromotions",
        //     group: "golfPromotions",
        //     path: PATHS.GOLF_PROMOTIONS.path,
        //     tagSub: "golfPromotions",
        //     exac: false,
        //     icon: "faPercent",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_PROMOTIONS,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
        // {
        //     title: "golfBookingAccount",
        //     group: "golfBookingAccount",
        //     path: PATHS.GOLF_BOOKING_ACCOUNT.path,
        //     tagSub: "golfBookingAccount",
        //     exac: false,
        //     icon: "faUser",
        //     show: true,
        //     routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_BOOKING_ACCOUNT,
        //     permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
        // },
    ]
}]
